<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-4">
          <div slot="header">
            <h4 class="card-title pl-1 f-20-mobile">Subir Planilha</h4>
          </div>
          <div class="col-md-6 mb-3">
            <label>Empresa originária dos dados (Buscar por idi ou CNPJ)</label>
              <input type="text" v-model="pesquisa_original" v-debounce:250ms="pesquisaInstalacaoOriginal" class="form-control">
              <div class="mt-2 bold">
                 <div>Idi: {{ empresa_original.idi }}</div>
                 <div>CNPJ: {{ empresa_original.cnpj }}</div>
                 <div>Nome: {{ empresa_original.nome_fantasia }}</div>
              </div>
          </div>
          <div class="col-md-6 mb-3 pl-0">
          <input type="file" accept=".csv" @change="processFile($event)" class="form-control">
          </div>
          <div class="ml-2 mt-3 flex-center-div">
            <input type="checkbox" v-model="checkExcluirProdutos">
            <label class="ml-1" style="margin: 0px;">Excluir produtos já cadastrados?</label>
          </div>
          <div class="pt-3 pb-1 d-inline">
            <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" @click="subirPlanilha">Subir planilha</button>
          </div>
          <div class="pt-3 pb-1 d-inline ml-4">
            <a href="modelo_produto.csv" class="btn btn btn-round btn-wd btn-linkedin mx-auto-mobile mb-2-mobile btn-primary">Baixar o template</a>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {
  Card,
} from 'src/components'
import moment from 'moment'
import "vue-select/dist/vue-select.css";
import loadApp from '@/services/InstalacaoService.js'

export default {
    components: {
      Card,
      moment,
    },
    data() {
      return {
        planilha:null,
        success:false,
        fail:false,
        idi:null,
        mensagem_erro:null,
        pesquisa_original:"",
        empresa_original:{},
        empresa: '',
        checkExcluirProdutos: false
      }
    },
    methods:{
      processFile(event) {
        var reader = new FileReader();
        reader.onload = (e)=>{
          this.planilha = e.target.result
        }
        reader.readAsBinaryString(event.target.files[0])
        console.log(this.planilha)
      },
      subirPlanilha(){
        
          let params = {
            "clear":this.checkExcluirProdutos,
            "idi": this.empresa_original.idi,
            "file": this.planilha
          }
        axios.post(process.env.VUE_APP_API_MOBILE_URL+'instalacoes/createcsv', params,{
            "Content-Type": "multipart/form-data"
        }).then(res => {
             this.$swal({
                title:"Sucesso!",
                icon:"success",
                text:"Produtos Criados!"
            })
        }).catch(err=>{
          this.$swal({
            title:"Erro",
            icon:"warning",
            text: err.response.data ? err.response.data.message : 'Erro interno!'
          })
        });
      },
      pesquisaInstalacaoOriginal(){
        loadApp.loadApp(this.pesquisa_original).then(res => {
          this.empresa_original = res.data[0]
          if(!this.empresa_original){
            this.empresa_original = {idi:null,cnpj:"Nenhuma Empresa Encontrada",nome_fantasia:"Nenhuma Empresa Encontrada"}
          }
          this.$forceUpdate()
        }).catch(err => {
          console.error(err)
        })
      },
    },
}
</script>

<style>
  .flex-center-div {
    display: flex;
    align-items: center;
  }
</style>
